module.exports = __webpack_public_path__ + "img/25eec9df7d429068a5e65236e534f45d.jpg";